<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['container-detail', getSelectedDEV && 'dev-selected-component']">
    <i4proTableDetailRecursive
      v-if="this.schema.items && this.schema.items.length > 0"
      :headers="this.schema.items[0].header"
      :items="this.schema.items"
    />
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],

  components: {
    i4proTableDetailRecursive: () => import('@/components/tables/i4pro-table-detail-recursive')
  }
};
</script>
